import React, { useContext, useEffect, useRef, useState } from 'react';
import SideArea from './SideArea';
import './center.css';
import Page3 from './Page3';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
import Page4 from './Page4';
import Spline from '@splinetool/react-spline'; // Import Spline from react-spline
import HomeText from './HomeText';
import bgm from './Assets/dotlings.glb'
import Projects from './Projects';
import Blog from './Blog';
import { addcontext } from '../ContextShare/ContextShare';
import cvPdf from './Assets/Adil_KK.pdf'
import Footer from './Footer';
import ChatBoat from '../ChatBoat/ChatBoat';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  height:'200px',
  bgcolor: '#080808',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  fontFamily:'Ropa sans'
};
function Home() {
  const {NavSelected,setNavSelected}=useContext(addcontext)
  const {ContactOpened,setContactOpened}=useContext(addcontext)
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);
  const [isPage2Active, setIsPage2Active] = useState(false);
  const logoRef = useRef(null);
  const logoHereRef = useRef(null);
  const videoRef = useRef(null);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.7; // Adjust the speed (0.5 = half speed)
    }
  }, []);
  useEffect(() => {
    const handleMouseMove = (event) => {
      if (!isPage2Active) {
        setMouseX(event.clientX);
        setMouseY(event.clientY);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []); // Update event listener when isPage2Active changes

   useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once while scrolling down
    });
  }, []);

  const handleScrollDown=()=>{
    window.scrollBy({ top: 400, left: 0, behavior: 'smooth' });
    // alert('k')
  }

  useEffect(() => {
    if (NavSelected === 'CV') {
      // Trigger PDF download
      const cvPdfUrl = cvPdf; // Update with the actual path to your CV PDF file
      const link = document.createElement('a');
      link.href = cvPdfUrl;
      link.download = 'Adil_kk.pdf'; // This will be the name of the downloaded file
      link.click();
      
      setNavSelected(''); // Reset NavSelected after download
    } 
    else if(NavSelected=='Public key'){
     handleOpen()
    }
    else if (NavSelected) {
      console.log(NavSelected);
      const section = document.getElementById(NavSelected);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        setNavSelected(''); // Reset NavSelected after scrolling
      }
    }
  }, [NavSelected]);
  const [randomNumber, setRandomNumber] = useState(null);

  useEffect(() => {
    const randomNum = Math.random() < 0.5 ? 1 : 2; // Randomly selects 1 or 2
    setRandomNumber(randomNum);
  }, []); // Runs only once on mount

  return (
    <>
      {/* Mouse glow ring */}
      <div 
        className="mouse-glow"
        style={{ top: mouseY, left: mouseX }}
      ></div>

      {/* Main content */}
      <div className="relative w-full h-dvh overflow-hidden bg-black">
        <div className="absolute top-0 left-0 w-full h-full z-0 pointer-events-auto opacity-55">
          {/* <ModelViewer modelUrl={glb2} /> */}
          {/* <video
           ref={videoRef}
            className="absolute top-0 left-0 w-full h-full object-cover "
            src="https://cdn.pixabay.com/video/2022/04/24/114986-703067603_large.mp4"
            autoPlay
            muted
            loop
            disablePictureInPicture
          ></video> */}
           <div style={{ width: '100%', height: '100%' }}>
      {/* Spline component to render the 3D scene */}
      <Spline scene={randomNumber==1?"https://prod.spline.design/nG41qYhCMZtXOakZ/scene.splinecode":"https://prod.spline.design/rNOZYMP5Ot-cKmq9/scene.splinecode"} />
      {/* old mo */}
      {/* <Spline scene="https://prod.spline.design/rNOZYMP5Ot-cKmq9/scene.splinecode" /> */}

    </div>

          
        </div>

        <div className="relative flex md:flex-row flex-col w-full h-full justify-between z-10 pointer-events-none">
          <div className="flex md:w-2/12 w-full ">
            <SideArea />
          </div>

          <div className="flex md:w-full w-full justify-center " >
            <div className='flex flex-row items-center justify-start min-h-screen w-full' style={{ fontFamily: 'Ropa Sans, sans-serif' }}>
              {/* text info of mine */}
              <div className='md:w-10/12 w-full items-center justify-start '> 
              {/* <HomeBio/> */}
              <HomeText/>
                
              </div> 

            </div>
          </div>
        </div>
      </div>
      <button onClick={handleScrollDown} title='scroll down' className='z-50 absolute bottom-5 w-7 h-10 rounded-xl border border-gray-400 flex items-start justify-center' style={{transform: 'translateX(-50%)', zIndex: 10,left:'50%',right:'50%'}}> <div className='scrollicon w-1 h-4 mt-1 bg-gray-200 rounded'></div></button>
      
      {ContactOpened&&<div className='flex w-full h-full justify-end p-5 absolute top-10 z-50'>
        <ChatBoat/>
      </div>}

    <div className='flex w-full h-full justify-start items-center  ' id='About me'>
        {/* Pass the activation state to Page2 */}
        <Page4 />
      </div>
      
      <div className='flex w-full h-full justify-start items-center ' id='Experience'>
      
        <Page3 />
      </div>

      <div className='flex w-full h-full justify-start items-center  ' id='Projects'>
        {/* Pass the activation state to Page2 */}
        {/* <Page2 /> */}
        <Projects modelUrl={bgm}/>

      </div>

      <div className='flex w-full h-full justify-start items-center ' id='Blogs'>
      
      <Blog />
    </div>

    <div className='flex w-full h-full justify-start items-center '>
      
      <Footer />
    </div>

    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" className='text-gray-200'>
            My SSH Key
          </Typography>
          <div className='px-8 py-2 mt-5 text-gray-300 bg-gray-900 rounded'>SHA256:TZ3zbfotkWblqRp6Cqgro45poqcIOCKCn+ATH64qkz8</div>
        </Box>
      </Modal>
    </>
  );
}

export default Home;
